import { useQuery } from "@tanstack/react-query";
import { PagedResponse } from "src/utils/types";
import { axiosCompanyInstance } from "src/config/axios";
import { StationModel } from "../types/Station";
import { removeEmptyKeysFromFilters } from "src/utils/object";

export const RQ_STATION_LIST_KEY = "STATION_LIST_KEY";

export type StationListResponse = PagedResponse<StationModel[]>;

export type StationListFilters = {
    id?: string;
    identifier?: string;
    locationId?: string;
    outlet?: string;
    status?: string;
    evseStatus?: string;
    tariffId?: string;
};

export const useStationList = (
    page: number,
    perPage: number,
    searchFilters: StationListFilters
) => {
    const filters = searchFilters ? removeEmptyKeysFromFilters(searchFilters) : {};

    return useQuery({
        queryKey: [
            RQ_STATION_LIST_KEY,
            page,
            perPage,
            filters.id ? `${filters.id}` : "",
            filters.identifier ? `${filters.identifier}` : "",
            filters.locationId ? `${filters.locationId}` : "",
            filters.outlet ? `${filters.outlet}` : "",
            filters.status ? `${filters.status}` : "",
            filters.evseStatus ? `${filters.evseStatus}` : "",
            filters.tariffId ? `${filters.tariffId}` : "",
        ],
        queryFn: async (): Promise<StationListResponse | null> => {
            const resp = await axiosCompanyInstance.get(`station`, {
                params: { ...filters, page: page + 1, perPage },
            });

            return resp?.data || null;
        },
    });
};
